<template>
	<by-container :showLoading="showLoading" :showNotContent="showNotContent">
		<div class="wrap clearfloat">
			<div class="aboutTit">
				<ul>
					<li v-for="(nav, index) in items" :key="index" :class="[(!$route.query.type && nav.type == 'train') || nav.type == $route.query.type ? 'active' : '']">
						<router-link :to="{ name: nav.src, query: { type: nav.type } }">{{ nav.title }}</router-link>
					</li>
				</ul>
			</div>
			
			<byNews v-if="!$route.query.type || $route.query.type == 'train'"></byNews>
			<byCurriculum v-else-if="$route.query.type == 'curriculum'"></byCurriculum>
			<byDownload v-else-if="$route.query.type == 'download'"></byDownload>
			
		</div>
	</by-container>
</template>

<script>
import byNews from './component/news.vue';
import byCurriculum from './component/curriculum.vue';
import byDownload from './component/download.vue';
export default {
	components: {
		// 引入组件
		byNews,
		byCurriculum,
		byDownload,
	},
	data() {
		return {
			showLoading: false, //页面加载状态
			showNotContent: false, //是否显示空

			items: [
				{ title: '电商培训', src: 'online', type: 'train', checked: false },
				{ title: '在线课程', src: 'online', type: 'curriculum', checked: false },
				// { title: '教材下载', src: 'online', type: 'download', checked: false }
			],

		};
	},
	props: {
		// 上级页面传递的数据
	},
	computed: {
		// 计算属性
	},
	created() {
		// 实例初始化
	},
	beforeCreate() {
		// 实例初始化之后
	},
	mounted() {
		// 实例被挂载后调用
	},
	updated() {
		// 数据更新后调用
	},
	activated() {
		// 缓存页面显示后调用
	},
	deactivated() {
		// 缓存页面隐藏后调用
	},
	methods: {},
	watch: {
		// 数据监听及回调
	}
};
</script>

<style scoped="scoped"></style>
